import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { JoveButton, JovePhoneNumberInputControlled, JoveTextFieldControlled } from '@jove-frontend/mui';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { FormProvider, useForm } from 'react-hook-form';
import { validateIsEmail } from '../../utils/formatValidate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var AIChatWindowWelcomeView = function AIChatWindowWelcomeView(props) {
  var className = props.className,
      getYourQuote = props.getYourQuote,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
      _props$connectionErro = props.connectionErrorMessage,
      connectionErrorMessage = _props$connectionErro === void 0 ? '' : _props$connectionErro,
      country = props.country;
  var methods = useForm({
    defaultValues: {
      phone: '',
      userEmail: ''
    }
  });
  var control = methods.control,
      handleSubmit = methods.handleSubmit,
      getValues = methods.getValues;

  var _useState = useState(country || 'GB'),
      userCountry = _useState[0],
      setUserCountry = _useState[1];
  /**
   * effects
   */


  useEffect(function () {
    setUserCountry(country || 'GB');
  }, [country]);
  /**
   * methods
   */

  var getYourQuoteAction = function getYourQuoteAction() {
    handleSubmit(chatWithUserInfo)();
  };

  var chatWithUserInfo = function chatWithUserInfo() {
    var _getValues = getValues(),
        phone = _getValues.phone,
        userEmail = _getValues.userEmail;

    getYourQuote === null || getYourQuote === void 0 ? void 0 : getYourQuote({
      phone: phone,
      email: userEmail
    });
  };

  var validateEmailCallback = function validateEmailCallback(value) {
    return validateIsEmail(value) ? true : 'Please enter correct email address';
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col overflow-hidden bg-[#F8FAFC]', className),
    children: [/*#__PURE__*/_jsxs(Box, {
      className: "flex flex-1 flex-col items-center justify-center space-y-5 px-6 text-center",
      children: [/*#__PURE__*/_jsx(Box, {
        className: "relative",
        children: /*#__PURE__*/_jsx("img", {
          src: "https://storage.googleapis.com/jove-public-images/ai/ai-avatar.png",
          className: "h-20 w-20 rounded-full object-cover",
          alt: "AI avatar"
        })
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle1",
        className: "font-medium leading-5 text-[#474747]",
        children: "I'm Mia \u2014 I'll help you get the right insurance in minutes. Drop your email so I can send you a summary."
      }), connectionErrorMessage && /*#__PURE__*/_jsx(Typography, {
        variant: "body2",
        className: "w-full rounded-md border border-[#FECACA] bg-[#FEF2F2] px-3 py-2 text-left text-[#B91C1C]",
        children: connectionErrorMessage
      }), /*#__PURE__*/_jsx(FormProvider, _objectSpread(_objectSpread({}, methods), {}, {
        children: /*#__PURE__*/_jsxs(Box, {
          className: "flex w-full flex-col space-y-2",
          children: [/*#__PURE__*/_jsx(JoveTextFieldControlled, {
            name: "userEmail",
            control: control,
            label: "Your email address",
            className: "w-full rounded bg-white",
            rules: {
              validate: validateEmailCallback
            }
          }), /*#__PURE__*/_jsx(JovePhoneNumberInputControlled, {
            name: "phone",
            control: control,
            label: "Your phone number",
            country: userCountry
          })]
        })
      }))]
    }), /*#__PURE__*/_jsx(Box, {
      className: "flex flex-col p-4",
      children: /*#__PURE__*/_jsx(JoveButton, {
        variant: "contained",
        size: "large",
        onClick: getYourQuoteAction,
        loading: isLoading,
        children: "Get your quote"
      })
    })]
  });
};

export default AIChatWindowWelcomeView;